class UrlsService{
    public login(): string {
        return "/login"
    }

    public app(): string {
        return "/"
    }

    public organizations(): string{
        return "/organizations"
    }

    public publisherLogins(): string{
        return "/publisher_logins"
    }

    public advertiserLogins(): string{
        return "/advertiser_logins"
    }

    public ownerships(): string{
        return "/ownerships"
    }

    public createOwnerships(): string{
        return "/ownership/add"
    }

    public editOrganization(id: string = ":id"): string {
        return `${this.organizations()}/${id}`
    }

    public editPublisherLogins(id: string = ":id"): string {
        return `${this.publisherLogins()}/${id}`
    }

    public editAdvertiserLogins(id: string = ":id"): string {
        return `${this.advertiserLogins()}/${id}`
    }

    public getOwnershipsByOrgId(id: string = ":id"): string {
        return `${this.ownerships()}/${id}`
    }

    public users(): string {
        return "/users"
    }

    public addUser(): string {
        return "/user/add"
    }

    public addOrganization(): string {
        return "/organization/create"
    }

    public editUsers(id: string = ":id"): string {
        return `${this.users()}/${id}`
    }



}

const urlService = new UrlsService();

export {urlService}